import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "wrapper" };
const _hoisted_2 = { class: "left-section d-flex justify-center align-center" };
const _hoisted_3 = { class: "header-title-text wh-pl pt-4" };
const _hoisted_4 = { class: "d-none justify-space-between" };
const _hoisted_5 = { class: "group-wrapper d-flex" };
const _hoisted_6 = { class: "group-wrapper d-flex align-center" };
const _hoisted_7 = { class: "button-text pointer" };
const _hoisted_8 = { class: "button-text pointer" };
const _hoisted_9 = { class: "login-button-wrapper" };
const _hoisted_10 = { class: "group-wrapper d-none justify-center align-center" };
const _hoisted_11 = { class: "caption-normal-text" };
import { ref, reactive, computed, } from 'vue';
import { trimTextField } from '@/utils';
import { i18n } from '@/locales';
import { useRouter } from 'vue-router';
import { BusinessError } from '@/error';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { userActionType } from '@/vuex-store/user/actions';
import { isRequired } from '../form/form-rules';
import InputRow from '../components/Form/InputRow.vue';
const lc = 'views.login.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesktopLogin',
    setup(__props) {
        const router = useRouter();
        const createFormData = () => ({
            username: '',
            password: '',
        });
        const createFormRules = () => ({
            username: computed(() => [
                (v) => isRequired(trimTextField(v)) || i18n.t('form_rules.value_require'),
            ]),
            password: computed(() => [
                (v) => isRequired(v) || i18n.t('form_rules.value_require'),
            ]),
        });
        const initFormData = createFormData();
        const isPasswordHidden = ref(true);
        const formRef = ref(null);
        const formValid = ref(false);
        const formRules = createFormRules();
        const formData = reactive(initFormData);
        const setFormData = (key, value) => {
            formData[key] = value;
        };
        const _validateForm = () => formRef.value.validate();
        const computedUsername = computed({
            get: () => formData.username,
            set: (value) => {
                setFormData('username', value);
            },
        });
        const computedPassword = computed({
            get: () => formData.password,
            set: (value) => {
                setFormData('password', value);
            },
        });
        const passwordInputType = computed(() => (isPasswordHidden.value ? 'password' : 'text'));
        const passwordInputIcon = computed(() => (isPasswordHidden.value ? 'mdi-eye-off' : 'mdi-eye'));
        const _onSubmit = async (submitData) => {
            try {
                await vuexStore.dispatch(userActionType.login, submitData);
                router.replace({
                    path: '/',
                }).catch(() => { });
            }
            catch (error) {
                console.log('_submit', error);
                let message = '';
                if (error instanceof BusinessError) {
                    message = error.message;
                }
                else {
                    message = error?.data.error?.message ?? i18n.t(`${lc}alert_recheck_user_info`);
                }
                // 로그인 로직 실패 시 스토어 정리
                vuexStore.dispatch(userActionType.clearUser);
                vuexStore.dispatch(snackbarActionType.showError, message);
            }
        };
        /**
         * 로그인 버튼 클릭 핸들러
         */
        const handleSubmitForm = async () => {
            const { valid } = await _validateForm();
            if (!valid) {
                // fail
                return vuexStore.dispatch(snackbarActionType.showInfo, {
                    message: i18n.t('common.form_validation_error'),
                });
            }
            // success
            return _onSubmit(formData);
        };
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _createVNode(_component_v_form, {
                        ref_key: "formRef",
                        ref: formRef,
                        modelValue: formValid.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((formValid).value = $event)),
                        class: "login-form",
                        onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                    }, {
                        default: _withCtx(() => [
                            _createCommentVNode(" 바로고 로고 "),
                            _cache[6] || (_cache[6] = _createElementVNode("img", {
                                src: "/svg/logo-barogo.svg",
                                alt: "barogo_로고",
                                class: "logo-barogo"
                            }, null, -1 /* CACHED */)),
                            _createCommentVNode(" 환영 텍스트 "),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(i18n).t(`${lc}welcome_text`)), 1 /* TEXT */),
                            _createCommentVNode(" 아이디 입력창 "),
                            _createVNode(InputRow, {
                                label: _unref(i18n).t(`${lc}login_id`),
                                "is-required": "",
                                "is-vertical-label": ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        "data-cy": "id",
                                        modelValue: computedUsername.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((computedUsername).value = $event)),
                                        dense: "",
                                        variant: "outlined",
                                        "hide-details": "auto",
                                        placeholder: _unref(i18n).t('common.input_field_placeholder', { field: _unref(i18n).t(`${lc}login_id`) }),
                                        rules: _unref(formRules).username.value
                                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"]),
                            _createCommentVNode(" 비밀번호 입력창 "),
                            _createVNode(InputRow, {
                                label: _unref(i18n).t(`${lc}login_password`),
                                "is-required": "",
                                "is-vertical-label": ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        "data-cy": "password",
                                        modelValue: computedPassword.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((computedPassword).value = $event)),
                                        dense: "",
                                        variant: "outlined",
                                        "hide-details": "auto",
                                        type: passwordInputType.value,
                                        "append-inner-icon": passwordInputIcon.value,
                                        placeholder: _unref(i18n).t('common.input_field_placeholder', { field: _unref(i18n).t(`${lc}login_password`) }),
                                        rules: _unref(formRules).password.value,
                                        "onClick:appendInner": _cache[2] || (_cache[2] = ($event) => (isPasswordHidden.value = !isPasswordHidden.value))
                                    }, null, 8 /* PROPS */, ["modelValue", "type", "append-inner-icon", "placeholder", "rules"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"]),
                            _createCommentVNode(" {{ i18n.t(`${lc}login_password`) }} "),
                            _createCommentVNode(" 현재 미사용 d-none class 추후 d-flex로 수정 "),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createCommentVNode(" 아이디 저장 체크박스 "),
                                    _createVNode(_component_v_checkbox, {
                                        class: "body2-text",
                                        label: _unref(i18n).t(`${lc}remember_id`)
                                    }, null, 8 /* PROPS */, ["label"]),
                                    _createCommentVNode(" 자동 로그인 체크박스 "),
                                    _createVNode(_component_v_checkbox, {
                                        class: "body2-text",
                                        label: _unref(i18n).t(`${lc}auto_login`)
                                    }, null, 8 /* PROPS */, ["label"])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createCommentVNode(" 아이디 / 비밀번호 찾기 링크 "),
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(i18n).t(`${lc}find_id`)), 1 /* TEXT */),
                                    _cache[5] || (_cache[5] = _createTextVNode(" | ")),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(i18n).t(`${lc}find_password`)), 1 /* TEXT */)
                                ])
                            ]),
                            _createCommentVNode(" 로그인 버튼 "),
                            _createElementVNode("div", _hoisted_9, [
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    "data-cy": "login-btn",
                                    type: "submit"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(i18n).t(`${lc}login`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            primary: true,
                                            info: true,
                                            "size-xl": true,
                                            "width-fill": true
                                        }
                                    ]
                                ])
                            ]),
                            _createCommentVNode(" 회원가입 현재 미사용 d-none class 추후 d-flex로 수정 "),
                            _createElementVNode("div", _hoisted_10, [
                                _createCommentVNode(" 회원가입 "),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(i18n).t(`${lc}info_signup`)), 1 /* TEXT */),
                                _createElementVNode("a", {
                                    class: "button-text",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"]))
                                }, _toDisplayString(_unref(i18n).t(`${lc}signup`)), 1 /* TEXT */)
                            ])
                        ]),
                        _: 1 /* STABLE */,
                        __: [6]
                    }, 8 /* PROPS */, ["modelValue"])
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("section", { class: "right-section bg-image" }, null, -1 /* CACHED */))
            ]));
        };
    }
});
